import React from 'react';
import { useTheme } from '../context/shared/ThemeContext';
import PageContainer from '../components/common/PageContainer';
import PageSection from '../components/common/PageSection';

const Legal: React.FC = () => {
  const { themeClasses } = useTheme();

  return (
    <PageContainer>
      <h1 className={`text-2xl font-bold mb-8 ${themeClasses.primaryText}`}>Legal & Privacy</h1>

      <PageSection title="Privacy Policy" emoji="🔒">
        <div className={`space-y-4 ${themeClasses.secondaryText}`}>
          <p>
            Your privacy is our top priority. We employ industry-standard security measures to protect your personal information and ensure your data remains confidential.
          </p>
          <p>
            We only collect and store information that's necessary to provide you with our services. Your chat history and personal data are encrypted and stored securely.
          </p>
        </div>
      </PageSection>

      <PageSection title="Terms of Service" emoji="📄">
        <div className={`space-y-4 ${themeClasses.secondaryText}`}>
          <p>
            By using Mentra, you agree to our terms of service. These terms outline your rights and responsibilities as a user, as well as our obligations to you.
          </p>
          <p>
            Our service is intended to provide support and guidance, but it is not a substitute for professional medical or mental health treatment.
          </p>
        </div>
      </PageSection>

      <PageSection title="Data Usage" emoji="📊">
        <div className={`space-y-4 ${themeClasses.secondaryText}`}>
          <p>
            We use your data to improve our services and provide you with personalized experiences. Your data is never sold to third parties.
          </p>
          <p>
            You can request a copy of your data or delete your account at any time through the settings page.
          </p>
        </div>
      </PageSection>

      <PageSection title="Contact Information" emoji="📧">
        <div className={`space-y-4 ${themeClasses.secondaryText}`}>
          <p>
            If you have any questions about our legal policies or your data, please contact our support team.
          </p>
          <p>
            For urgent matters, you can reach us through the help section in your dashboard.
          </p>
        </div>
      </PageSection>
    </PageContainer>
  );
};

export default Legal; 